// extracted by mini-css-extract-plugin
module.exports = {"root":"DefaultLayout_root__GRgJg","content":"DefaultLayout_content__Y6WHd","headerBack":"DefaultLayout_headerBack__pf5y_"};